import React from 'react';
import PropTypes from 'prop-types';
import { FloatingActionButton } from 'material-ui';
import { ContentAdd } from 'material-ui/svg-icons';

const style = {
  position: 'fixed',
  bottom: 16,
  right: 16,
};

const AddFloatingButton = props => (
  <FloatingActionButton
    backgroundColor="#004f94"
    {...props}
    style={{ ...props.style, ...style }}
  >
    <ContentAdd />
  </FloatingActionButton>
);

AddFloatingButton.propTypes = {
  style: PropTypes.shape({}),
};

export default AddFloatingButton;



// WEBPACK FOOTER //
// ./src/components/AddFloatingButton.js